export async function requestImpersonationAndNavigate({ store, navigate, target, reason }) {
	const outcome = await store.requestImpersonation(target, reason)
	if (outcome.started) navigate('/impersonation')
	return outcome
}

export async function elevateAndContinueImpersonation({ store, navigate, password }) {
	const outcome = await store.elevateAndContinue(password)
	if (outcome.started) navigate('/impersonation', { replace: true })
	return outcome
}
